/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ConfigureGenesysBotConnectorStepMessages = defineMessages({
  title: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.title',
    defaultMessage: 'Configure your Genesys Bot Connector'
  },
  stepOne: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.stepOne',
    defaultMessage: `Copy the {generatedURI} below, go to the Genesys Configuration tab in Properties, and paste over and replace the {placeholderWebhookURI} you entered during setup for the Handle Utterance URI.`
  },
  generatedURI: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.generatedURI',
    defaultMessage: `generated URI`
  },
  placeholderWebhookURI: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.placeholderWebhookURI',
    defaultMessage: `placeholder webhook URI`
  },
  generatedRequestUrlLabel: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.generatedRequestUrlLabel',
    defaultMessage: 'Generated request URL'
  },
  note: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.note',
    defaultMessage:
      'The generated request URL will be using the latest Watson Assistant service API version. <link>Learn more</link>'
  },
  stepThree: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.stepThree',
    defaultMessage: 'Click {saveChanges}.'
  },
  generateCallbackUrl: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.generateCallbackUrl',
    defaultMessage: 'Generate callback URL'
  },
  webhookErrorTitleGenesys: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.webhookErrorTitleGenesys',
    defaultMessage:
      "We're unable to connect to your Genesys bot connector account."
  },
  webhookErrorSubtitleGenesys: {
    id: 'GenesysBotConnector.ConfigureGenesysBotConnectorStepMessages.webhookErrorSubtitleGenesys',
    defaultMessage:
      'Please check your account details on the previous page & try again.'
  }
});
